import { Reveal } from "@/components/Reveal";
import { useSiteConfig } from "@/context/SiteConfigContext";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { config } = useSiteConfig();
  const t = config.t.faq;
  const FAQS = config.lists.faqs;
  return (
    <section id="faq" className="bg-white py-28 sm:py-36" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-6">
        <Reveal className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mt-4 text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl">{t.heading}</h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`}
                className="overflow-hidden rounded-2xl border border-black/5 bg-[#FAFAFC] px-5"
                data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left text-[16px] font-semibold text-neutral-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-neutral-500">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
